import type { RouteRecordRaw } from 'vue-router';

const MainLayout = () => import('@/shared/layouts/pages/MainLayout/index.vue');
const RegularizationConfirmPage = () =>
  import('@/shared/jumioRegularization/pages/RegularizationConfirm/index.vue');
const RegularizationPendingPage = () =>
  import('@/shared/jumioRegularization/pages/RegularizationPending/index.vue');

export const jumioRegularizationRoutes: Array<RouteRecordRaw> = [
  {
    path: '/regularizacion-jumio',
    component: MainLayout,
    meta: { hideSidebar: true },
    children: [
      {
        path: 'confirmacion',
        name: 'jumio-regularization-confirm',
        component: RegularizationConfirmPage,
        meta: {
          requiresAuth: true,
          title: 'Confirma la información de los representantes legales',
        },
      },
      {
        path: 'validaciones',
        name: 'jumio-regularization-pending',
        component: RegularizationPendingPage,
        meta: {
          requiresAuth: true,
          title: 'Completa las validaciones de identidad pendientes',
        },
      },
    ],
  },
];
